__turbopack_context__.v({
  "breadcrumbContainer": "AllFeaturesPage-module-scss-module__LEpAra__breadcrumbContainer",
  "featuresDescriptionContainer": "AllFeaturesPage-module-scss-module__LEpAra__featuresDescriptionContainer",
  "featuresPageContainer": "AllFeaturesPage-module-scss-module__LEpAra__featuresPageContainer",
  "featuresPageImage": "AllFeaturesPage-module-scss-module__LEpAra__featuresPageImage",
  "featuresPageItemsContainer": "AllFeaturesPage-module-scss-module__LEpAra__featuresPageItemsContainer",
  "featuresTitleContainer": "AllFeaturesPage-module-scss-module__LEpAra__featuresTitleContainer",
  "imageContainer": "AllFeaturesPage-module-scss-module__LEpAra__imageContainer",
  "playBtn": "AllFeaturesPage-module-scss-module__LEpAra__playBtn",
  "singleFeaturePageItemButton": "AllFeaturesPage-module-scss-module__LEpAra__singleFeaturePageItemButton",
  "singleFeaturePageItemContainer": "AllFeaturesPage-module-scss-module__LEpAra__singleFeaturePageItemContainer",
  "singleFeaturePageItemDescription": "AllFeaturesPage-module-scss-module__LEpAra__singleFeaturePageItemDescription",
  "singleFeaturePageItemSubtitle": "AllFeaturesPage-module-scss-module__LEpAra__singleFeaturePageItemSubtitle",
  "singleFeaturePageItemTitle": "AllFeaturesPage-module-scss-module__LEpAra__singleFeaturePageItemTitle",
  "srOnly": "AllFeaturesPage-module-scss-module__LEpAra__srOnly",
  "verticalActiveLine": "AllFeaturesPage-module-scss-module__LEpAra__verticalActiveLine",
});
